"use client";

import { Compass } from "lucide-react";
import Image from "next/image";

export function SignatureExperiencesSection({
  lookUpCMSData,
  homeDetails,
}: any) {
  return (
    <section className="py-10 md:py-20 bg-[#F9F7F4]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {lookUpCMSData?.["Home - Section 5 : Signature Moments"] ? (
          <div
            dangerouslySetInnerHTML={{
              __html:
                lookUpCMSData?.[
                  "Home - Section 5 : Signature Moments"
                ]?.Template?.trim(),
            }}
          />
        ) : (
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full mb-6">
              <Compass className="h-4 w-4 text-[#B42025]" />
              <span className="text-[#B42025] tracking-[0.3em] text-sm uppercase">
                Signature Moments
              </span>
            </div>
            <h2 className="text-4xl md:text-6xl mb-6 text-[#1A1A1A]">
              Signature Experiences
            </h2>
            <p className="text-gray-600 text-xl max-w-3xl mx-auto">
              Every Kavish stay comes with moments that stay with you long after
              you return.
            </p>
          </div>
        )}

        {/* <SignatureMomentSlider data={homeDetails?.Signature || []} /> */}
        {/* {false && ( */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {homeDetails?.Signature?.slice(0, 6)?.map(
            (experience: any, index: number) => (
              <div
                key={index}
                className="relative group overflow-hidden rounded-2xl aspect-square cursor-pointer shadow-xl hover:shadow-2xl transition-all duration-500"
              >
                <Image
                  src={experience?.Image}
                  alt={experience?.Title}
                  className="object-cover group-hover:scale-110 transition-transform duration-700"
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500" />

                {/* Number Badge */}
                {/* <div className="absolute top-6 right-6">
                  <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center">
                    <span className="text-white text-sm">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>
                </div> */}

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-8 transform group-hover:translate-y-0 transition-transform duration-500">
                  <p className="text-[#C9A962] text-sm tracking-wider mb-2 uppercase">
                    {experience?.Tag}
                  </p>
                  <h3 className="text-white text-2xl mb-4 leading-tight">
                    {experience?.Title}
                  </h3>
                  <div className="w-16 h-0.5 bg-[#C9A962] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
                </div>
              </div>
            ),
          )}
        </div>
        {/* )} */}
      </div>
    </section>
  );
}
